/* eslint-disable @typescript-eslint/no-empty-interface */
import * as React from "react";
import { useState, useRef, useEffect } from "react";

import { connect } from "react-redux";
import { Button } from "reactstrap";
import { Table } from "reactstrap";
import {
  Field,
  reduxForm,
  getFormValues,
  InjectedFormProps,
  getFormNames,
} from "redux-form";
import deleteIcon from "../../../../images/delete.svg";
import IndividualIcon from "../../../../images/individual-user.svg";
import businessIcon from "../../../../images/business-and-trade.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import userIcon from "../../../../images/userIcon.svg";

import {
  OwnershipInformationdata,
  saveOwnershipInformationdata,
  State,
  updateOwnershipInformationdata,
} from "./Ownershipinfomationdata";
import { toast } from "react-toastify";
import { AxiosError, AxiosResponse } from "axios";
import { cloneDeep, initial } from "lodash";
import validate from "./OwnershipValidate";
import { Input } from "reactstrap";
import { catchError } from "../../../../utils/Utils";
import YesOrNo from "../../../../commonfields/YesorNoSelect";
import NormalizeNumber from "../../../AdminSettings/Organization/NormalizeNumber";
import normaliseZipcode from "../../../../utils/normaliseZipCode";
import ReactSelectField from "../../../../commonfields/ReactSelectFeiled";
import Service from "../../../../services";
import { useParams } from "react-router-dom";
import TextField from "../../../../commonfields/TextField";
import { SelectField } from "common-fields";




interface OwnershipQuestionnarieFormProps {
  OwnershipInformationdata: OwnershipInformationdata | null;
  getAllOwnershipContacts: any;
  getIndividuals: any;
  entityType: any;
  getStockSymbol: any;
  newRowValues?: any;
  updateNewRowValues?: any;
  updateBulkRowValues?: any;
  resetNewRowValues?: any;
  clientProductsId?: any;
  disableFields?: boolean;
  ownersInformation?: any;
}
const OwnershipQuestionnarieForm: React.FunctionComponent<
  // eslint-disable-next-line @typescript-eslint/ban-types
  OwnershipQuestionnarieFormProps &
  InjectedFormProps<any, OwnershipQuestionnarieFormProps>
> = (props: any) => {
  const [individualContacts, setIndividualContacts] = useState<any>([]);
  const [addedRows, setAddedRows] = useState<any>([]);
  // const Userdetails = React.useContext(UserContext);
  //const [newRowValues, setNewRowValues] = useState<any>({type:{value:'Individuals'}});
  const [loader, setLoader] = useState<boolean>(false);
  const [businessOwners, setBusinessOwners] = useState<any>({});
  const [stockSymbol, setStockSymbol] = useState<any>({});
  const service = new Service();
  const [targetTop, setTargetTop] = useState("0");
  const [states, setStates] = useState<State[]>([]);
  const { clientProductId } = useParams();

  const typeValues = [
    // { value: "", label: "Select", disabled: true },
    {
      value: "Business",
      label: (
        <div className="option-box">
          <div className="icon">
            <img src={businessIcon} alt="businessIcon" />
          </div>
          <div className="text">Business</div>
        </div>
      ),
    },
    {
      value: "Individuals",
      label: (
        <div className="option-box">
          <div className="icon">
            <img src={IndividualIcon} alt="IndividualIcon" />
          </div>
          <div className="text">Individual</div>
        </div>
      ),
    },
  ];

  const yesNoValues = [
    { value: "true", text: "Yes" },
    { value: "false", text: "No" },
  ];
  const yesorNo = [
    { value: "Yes", text: "Yes" },
    { value: "No", text: "No" },
  ];

  const [newRow, setNewRow] = useState(false);

  const isEntityType = (type: string) => {
    return props.entityType?.text === type;
  }

  // const resetNewRowValues = ()=>{
  //   if(isEntityType("Sole Proprietorship")){
  //     const temp  = cloneDeep(newRowValues);
  //     temp.ownership = 100;
  //     temp.type = {value:'Individuals'};
  //     setNewRowValues(temp);
  // }
  // }
  const getStates = () => {
    const payload = {

      "screen": "Ownership module",

      "sections": "getStatesFilter",

      "isJsonReturnObject": true,

      "orgId": "a3fe60fe-3f6f-11ee-be56-0242ac120002"


    }
    service.getStatesData(payload)
      .then((resp: any) => setStates(resp.data))
      .catch((error: AxiosError) => {
        setStates([]);
        catchError(error, true);
      });
  }

  const getChildren = (
    _owners: any,
    type: string,
    owners: Array<OwnershipInformationdata>
  ) => {
    const temp: any = {};
    const _businessOwners = _owners[type].owners.filter(
      (o: any) => o.type === "Business"
    );
    _businessOwners.forEach((bO: any) => {
      temp[bO.ownerId] = {};
      temp[bO.ownerId].owners = owners.filter(
        (o) => o.parentOwnerId === bO.ownerId
      );
      temp[bO.ownerId]["answer"] =
        temp[bO.ownerId]["owners"][0]?.publicTradedCompany;
      temp[bO.ownerId].children = getChildren(temp, bO.ownerId, owners);
    });
    return temp;
  };

  const groupByOwners = (owners: Array<OwnershipInformationdata>) => {
    owners = owners || [];
    const bOwners: any = {
      parent: {
        owners: [],
      },
    };
    bOwners.parent.owners = owners.filter((o: any) => !o.parentOwnerId);
    bOwners.parent.answer = bOwners.parent.owners[0]?.publicTradedCompany + "";
    bOwners.parent.children = getChildren(bOwners, "parent", owners);

    setBusinessOwners(bOwners);
  };

  const getAllOwnershipContacts = () => {
    service
      .getAllContacts(clientProductId)
      .then((response: AxiosResponse<OwnershipInformationdata[]>) => {
        const owners = response.data || [];
        setIndividualContacts(owners);
        groupByOwners(owners);
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      });
  };

  const updateIndividualContacts = (ownerId: any, f: any, v: any) => {
    // const contacts = individualContacts.map((c:any)=>{
    //    if(ownerId === c.ownerId){
    //        c[f] = v;
    //    }
    // });

    setIndividualContacts(individualContacts);
    groupByOwners(individualContacts);
  }


  const saveStackSymbol = (data: any) => {
    setLoader(true);

    delete data.parentOwnerId;
    if (stockSymbol) {
      data.stockSymbolId = stockSymbol.stockSymbolId;

    }
    data.publicTradedCompany = data.publicTradedCompany + "";
    data.duplicateIndividuals = data.duplicateIndividuals || "";
    data.clientProductsId = props?.clientProductsId;
    let payload = cloneDeep(data);
    if (payload.publicTradedCompany == 'false') {
      payload = {
        publicTradedCompany: payload.publicTradedCompany,
        stockSymbolId: payload.stockSymbolId,
        clientProductsId: props.clientProductsId,
      };
    }
    service.postSaveStockSymbol(payload).then((response: any) => {
      setLoader(false);
      getAllOwnershipContacts();
      props.getAllOwnershipContacts();
      props.getIndividuals();
      props.getStockSymbol();
      if (response.status === 200) {
        // console.log("res", response);
      }
    });
  };

  const saveRow = (row: saveOwnershipInformationdata, mode: string, type?: string) => {
    setLoader(true);
    row.clientProductsId = props.clientProductsId;
    if (row.ownerId || row.parentOwnerId) {
      const found = props?.ownersInformation?.find((o: any) => (o.ownerId) === (row.ownerId || row.parentOwnerId));
      row.primarySigner = found?.primarySigner || false;
    }
    if ((row.stockSymbol || type === 'stockSymbol') && !row.ownerId) {
      saveStackSymbol(row);
    } else if (mode === "add" || mode === "update") {

      service
        .postOwnerInformation(row)
        .then((response: any) => {
          setLoader(false);
          setNewRow(false);
          //setNewRowValues({});
          props.resetNewRowValues(row.parentOwnerId || 'parent')
          props?.reset("OwnershipQuestionnarieForm");
          if (response.status === 200) {
            // toast.success(
            //   <>
            //     <div className="fileErrorMessage">contact saved</div>
            //   </>
            // );
            if (row.parentOwnerId) {
              const temp = cloneDeep(individualContacts);
              const owner = temp.find((c: any) => c.ownerId === row.parentOwnerId) || {};
              owner.newRow = false;
              setIndividualContacts(temp);
            }

            else {
              setStockSymbol({ ...stockSymbol, newRow: false });
            }


            getAllOwnershipContacts();
            props.getAllOwnershipContacts();
            props.getIndividuals();

            props.getStockSymbol();
          }
        })

        .catch((er: any) => {
          if (er.response.data.code === 400) {
            toast.error(
              <>
                <div className="fileErrorMessage">
                  {er.response.data.errorMessage}
                </div>
              </>
            );
          } else {
            catchError(er, true);
          }
          setLoader(false);
        });
    }
  };

  const getTotal = (id: any, ownerId: any = null) => {
    let total = 0;
    individualContacts
      .filter((o: any) => {
        if (ownerId && ownerId === o.ownerId) {
          return false;
        }
        if (id === "parent" && !o.parentOwnerId) {
          return true;
        }
        if (id !== "parent" && id === o.parentOwnerId) {
          return true;
        }

        return false;

      })
      .map((o: any) => {
        total += +o.ownership;
      });

    return total;
  };
  const getOwner = (id: string) => {
    return individualContacts.find((c: any) => c.ownerId === id) || {};
  };
  const changeField = (
    f: string,
    v: any,
    parentId: string,
    ownerId: string | null
  ) => {
    let isYesClicked = "false";
    if (f == "stockSymbol") {
      isYesClicked = "true";
    }
    const row = (ownerId && getOwner(ownerId)) || {};
    if ((f === "ownership" && v > 100)) {
      return;
    }
    if (f === "ownership") {
      if (getTotal(parentId, ownerId) + v > 100) {
        return false;
      }

    }
    if ((row && ownerId) || f == "stockSymbol") {
      row[f] = v;

      row.publicTradedCompany = isYesClicked;
      if (f !== 'stockSymbol') {
        row.ownerId = ownerId;
        row.type = row?.type?.value ?? row?.type;
      }

      if (row.parentOwnerId === "parent") {
        row.parentOwnerId = null;
      }
      if (
        (((row?.type === "Business" && row["firstname"]) ||
          (row?.type === "Individuals" &&
            row["firstname"] &&
            row["lastname"])) &&
          row["address1"] &&
          row["city"] &&
          row["state"] &&
          row["zipcode"] &&
          row["ownership"] &&
          ((!row.parentOwnerId &&
            row?.type === "Individuals" &&
            row["corporateOfficer"] &&
            row["authSigner"]) ||
            row.parentOwnerId ||
            row?.type === "Business")) || (f == "stockSymbol")) {
        saveRow(row, "update", f);
      } else {
        updateIndividualContacts(ownerId, f, v);
        //props.updateNewRowValues(f, v, parentId || "parent");
      }
    } else {
      // if (f !== "type" && f !== "stockSymbol") {
      //   setNewRowValues({ ...newRowValues, [f]: v });
      //   return;
      // }
      const _newRowValues = cloneDeep(props.newRowValues[parentId || 'parent']) || {};
      _newRowValues[f] = v;

      if (isEntityType("Sole Proprietorship")) {
        _newRowValues.type = _newRowValues.type || {};
        _newRowValues.type.value = 'Individuals';
        //_newRowValues.ownership = '100';

      }
      if (((_newRowValues?.type?.value === 'Business' && _newRowValues["firstname"])
        ||
        (_newRowValues?.type?.value === 'Individuals' && _newRowValues["firstname"] && _newRowValues["lastname"]))
        && _newRowValues["address1"] && _newRowValues["city"]
        && _newRowValues["state"] && _newRowValues["zipcode"] && _newRowValues["ownership"]
        && ((parentId === "parent" && _newRowValues?.type?.value === 'Individuals'
          && _newRowValues["corporateOfficer"] && _newRowValues["authSigner"])
          || parentId !== "parent" || _newRowValues?.type?.value === 'Business')) {

        props.updateNewRowValues(f, v, parentId || 'parent');
        if (getTotal(parentId) + (+_newRowValues['ownership']) > 100) {
          return false;
        }
        let p = {
          ..._newRowValues,
          [f]: v,
          parentOwnerId: parentId === "parent" ? null : parentId,
          clientProductsId: props.clientProductsId,
        };
        if (f === "stockSymbol") {
          // p.type = 'Personal';
          const owner = (ownerId && getOwner(ownerId)) || {};
          p = { ...p, ...owner, publicTradedCompany: "true" };
        }
        p = { ...p, type: p?.type?.value ?? p?.type };

        saveRow(p, "add");

      } else {
        props.updateNewRowValues(f, v, parentId || "parent");
      }
    }
  };

  const formElement: any = useRef();

  const addRow = (e: Event, id: string) => {
    e.preventDefault();
    props.resetNewRowValues(id);
    props?.reset("OwnershipQuestionnarieForm");
    //setNewRow(true);
    if (id !== "parent") {
      let temp = cloneDeep(individualContacts);
      temp = temp.map((o: any) => {
        o.edit = false;
        return o;
      });
      const owner = temp.find((c: any) => c.ownerId === id) || {};
      owner.newRow = true;
      setIndividualContacts(temp);
      // const temp2  = cloneDeep(newRowValues);
      // temp2.ownership = 100;
      // temp2.type = {value:'Individuals'};
      // temp2.corporateOfficer = 'N/A';
      // setNewRowValues(temp2);
      props.updateBulkRowValues({ 'ownership': 100, 'type': { value: 'Individuals' } }, id);
      //props.updateNewRowValues('type',{value: 'Individuals'}, id);
      //props.updateNewRowValues('corporateOfficer','N/A', id);
    } else {
      const temp = cloneDeep(stockSymbol);
      temp.publicTradedCompany = 'false'
      temp.newRow = true;
      setStockSymbol(temp);
      // const temp3  = cloneDeep(newRowValues);
      // temp3.ownership = 100;
      // temp3.type = {value:'Individuals'};
      // temp3.corporateOfficer = 'N/A';
      // setNewRowValues(temp3);
      props.updateBulkRowValues({ 'ownership': 100, 'type': { value: 'Individuals' } }, id);


      let temp2 = cloneDeep(individualContacts);
      temp2 = temp2.map((o: any) => {
        o.edit = false;
        return o;
      });
      setIndividualContacts(temp2);
    }
  };

  const changeStockSymbol = (e: any, id: string) => {
    e.preventDefault();

    //setNewRow(true);
    if (id === "parent") {
      setStockSymbol({ ...stockSymbol, stockSymbol: e.target?.value });
    } else {
      // const temp = cloneDeep(businessOwners);
      // temp[id].owners[0].stockSymbol = e.target?.value;
      // setBusinessOwners(temp);
      const temp = cloneDeep(individualContacts);
      const owner = temp.find((c: any) => c.ownerId === id) || {};
      owner.stockSymbol = e.target?.value;
      setIndividualContacts(temp);
    }
  };

  const changeSelectedIndex = (id: string, value: any) => {
    // const temp = cloneDeep(businessOwners);
    // temp[id].selectedIndex = value;
    // setBusinessOwners(temp);
    if (id === "parent") {
      const temp = cloneDeep(stockSymbol);
      temp.selectedIndex = value;
      setStockSymbol(temp);
    } else {
      const temp = cloneDeep(individualContacts);
      const owner = temp.find((c: any) => c.ownerId === id) || {};
      owner.selectedIndex = value;
      setIndividualContacts(temp);
    }
  };

  const deleteContact = (selectedOwnerId: any, id: any = '') => {
    service
      .deleteContact(selectedOwnerId, props?.clientProductsId)
      .then((response: any) => {
        setLoader(false);

        if (response.status === 200) {
          toast.success(
            <>
              <div className="fileErrorMessage">contact Deleted</div>
            </>
          );
          getAllOwnershipContacts();
          //setNewRowValues({});
          props.resetNewRowValues(id);
          props?.reset("OwnershipQuestionnarieForm");
          changeSelectedIndex(id, -1);
          props.getAllOwnershipContacts();
          props.getIndividuals();
        }
      })

      .catch((error: any) => catchError(error, true));
  }

  const removeRowData = (id: string) => {
    setLoader(true);
    if (
      ((id !== "parent" &&
        (Number(getOwner(id)?.selectedIndex + "") >= 0
          ? getOwner(id)?.selectedIndex
          : -1)) ||
        (id === "parent" &&
          (Number(stockSymbol?.selectedIndex + "") >= 0
            ? stockSymbol?.selectedIndex
            : -1))) >= 0
    ) {
      const owners = individualContacts.filter((o: any) => {
        if (id !== "parent") {
          return o.parentOwnerId == id;
        } else {
          return !o.parentOwnerId;
        }
      });
      const pO = id !== "parent" ? getOwner(id) : stockSymbol;
      const selectedOwnerId = owners[pO.selectedIndex]?.ownerId;
      selectedOwnerId && deleteContact(selectedOwnerId, id);
      // props.getIndividuals();

    }
  };

  const getStockSymbol = () => {
    setLoader(true);
    service
      .getStockSymbol(clientProductId)
      .then((response: any) => {
        setLoader(false);
        setStockSymbol(response?.data || {});
      })

      .catch((error: AxiosError) => {
        catchError(error, true);
      });
  };

  useEffect(() => {
    getAllOwnershipContacts();
    getStockSymbol();
    getStates();
  }, []);

  useEffect(() => {
    if (isEntityType("Sole Proprietorship")) {

      // props.updateNewRowvalues('ownership', 100, 'parent')

      //resetNewRowValues();

    }

  }, [props.entityType]);

  const isElgibleAddRow = (id: any) => {
    const total = getTotal(id);

    return total <= 100;
  };
  const ismangeingMemberHeading = () => {
    if (isEntityType('C-Corp') || isEntityType('Sole Proprietorship') || isEntityType('Other') || isEntityType('Corporation')) {
      return "Corporate Officer"
    }
    if (isEntityType('Limited Liability Company') || isEntityType('LLC')) {
      return "Managing Member"
    }
    if (isEntityType('Partnership')) {
      return "Managing Partner"
    }
    return "Corporate Officer"
  }
  // const isTypeDisabled = (id: any) => {
  //   const type = saveRow(onAnswer.type.value, "add")
  // }

  const displayRemove = (id: any) => {
    if (id === "parent") {
      const temp = cloneDeep(stockSymbol);
      temp.hasRemoveRow = true;
      setStockSymbol(temp);
    } else {
      const temp = cloneDeep(individualContacts);
      const owner = temp.find((c: any) => c.ownerId === id) || {};
      owner.hasRemoveRow = true;
      setIndividualContacts(temp);
    }
  };

  const hideRemove = (id: any) => {
    if (id === "parent") {
      const temp = cloneDeep(stockSymbol);
      temp.hasRemoveRow = false;
      temp.selectedIndex = -1;
      setStockSymbol(temp);
    } else {
      const temp = cloneDeep(individualContacts);
      const owner = temp.find((c: any) => c.ownerId === id) || {};
      owner.hasRemoveRow = true;
      owner.selectedIndex = -1;
      setIndividualContacts(temp);
    }
  };

  const onDelete = (e: Event, index: number, id: any, ownerId: any) => {
    if (id === "parent") {
      const temp = cloneDeep(stockSymbol);
      temp.selectedIndex = index;
      temp.selectedOwnerId = ownerId;
      setStockSymbol(temp);
      setTargetTop((index + 1) * 36.6 + "px");
    } else {
      const temp = cloneDeep(individualContacts);
      const owner = temp.find((c: any) => c.ownerId === id) || {};
      owner.selectedIndex = index;
      owner.selectedOwnerId = ownerId;
      setIndividualContacts(cloneDeep(temp));
      setTargetTop((index + 1) * 36.6 + "px");
    }
  };
  const deleteOwnersData = (id: any = null) => {
    const _owners = individualContacts.filter((owner: any) => owner.parentOwnerId == id)
    _owners.length && service.deleteAllOwners(id, props.clientProductsId).then((response: any) => {
      getAllOwnershipContacts();
      props.getAllOwnershipContacts();
      props.getIndividuals();
    });
  };

  const onAnswer = (answer: boolean, id: string) => {
    if (id !== "parent") {
      const temp = cloneDeep(individualContacts);
      const _owner = temp.find((c: any) => c.ownerId === id) || {};
      _owner.publicTradedCompany = answer;
      _owner.clientProductsId = props.clientProductsId;
      //temp[id]["answer"] = answer;
      saveRow(_owner, "update"); //to do save publicTradedCompany for yes no

      setIndividualContacts(temp);

    } else {
      const temp = cloneDeep(stockSymbol);
      temp.publicTradedCompany = answer;
      temp.clientProductsId = props.clientProductsId;
      if ((answer + '') == 'false') {
        temp.stockSymbol = '';
      }
      setStockSymbol(temp);
      saveStackSymbol(temp);
    }
    if (answer + "" == "true") {
      deleteOwnersData(id === "parent" ? null : id);
    }
    //  else {
    //   if(id!=='parent'){
    //     const temp = cloneDeep(individualContacts);
    //     const owner = temp.find((c: any) => c.ownerId === id) || {};
    //     owner.newRow = true;
    //     setIndividualContacts(temp);
    //   } else {
    //      setStockSymbol({...stockSymbol, newRow: true});
    //   }
    // }
  };

  const getName = (row: any, type: string) => {
    if (type === "name") {
      return [
        row.prefix,
        row.firstname,
        row.middleName,
        row.lastname,
        row.suffix,

      ]
        .filter((v) => v)
        .join(" ");
    }
    if (type === "address") {
      return [row.address1, row.address2, row.city, row.state, row.zipcode]
        .filter((v) => v)
        .join(" ");
    }
  };

  const updateIntialValues = (row: any) => {
    Object.keys(row).forEach((r) => {
      props.change(r, row[r]);

    });
  };

  const editEnable = (row: any, index: number) => {
    if (!props.disableFields) {
      let temp = cloneDeep(individualContacts);
      temp = temp.map((o: any) => { o.edit = false; o.newRow = false; return o })
      const _owner = temp.find((c: any) => c.ownerId === row.ownerId) || {};
      _owner.edit = true;
      _owner.selectedIndex = index;
      setIndividualContacts(temp);

      const temp2 = cloneDeep(stockSymbol);
      temp2.newRow = false;
      if (!row.parentOwnerId) {
        temp2.selectedIndex = index;
      }
      setStockSymbol(temp2);
    }
  };
  const renderQuestion = (id: string, _parent?: any) => {
    const _owner = getOwner(id);
    const owners =
      id === "parent"
        ? businessOwners[id]?.owners || []
        : _parent[id].owners || [];
    const fName = [
      _owner.firstname || "",
      _owner.middleName || "",
      _owner.lastname || "",
      _owner.prefix || "",
      _owner.suffix || "",
    ]
      .filter((v) => v)
      .join(" ");
    const question = (id === "parent")
      ? ("Is the applying company a publicly traded company?")
      : (`Is ${fName} company a publicly traded company?`);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    { !(isEntityType("Sole Proprietorship")) ? question : "" }
    return (
      <>
        {!(isEntityType("Sole Proprietorship")) ? <div>
          <div>
            <Field
              component={YesOrNo}
              name={"question_" + id}
              className="yesOrQuestions"
              label={question}
              helpText={question}
              isRequired="true"
              disabled={props.disableFields}
              defaultValue={
                id !== "parent"
                  ? getOwner(id)?.publicTradedCompany
                  : stockSymbol?.publicTradedCompany
              }
              options={yesNoValues}
              onChange={(a: any) => onAnswer(a, id)}
            />
          </div>
        </div> : ''}
        {(id !== "parent" && getOwner(id)?.publicTradedCompany == "true") ||
          (id == "parent" && stockSymbol.publicTradedCompany == "true") && !(isEntityType("Sole Proprietorship")) ? (
          <div className="stocksymbol">
            <span className="stocktext">
              Please provide the company stock symbol:
            </span>
            <Input
              type={"text"}
              autoComplete="off"
              className="stockSymbolTextbox"
              disabled={props.disableFields}
              value={
                id === "parent"
                  ? stockSymbol?.stockSymbol
                  : getOwner(id)?.stockSymbol
              }
              onChange={(e: any) => changeStockSymbol(e, id)}
              onBlur={(e: any) =>
                e.target.value && changeField("stockSymbol", e.target.value, id, _owner?.ownerId)

              }
            />
          </div>
        ) : (id !== "parent" && getOwner(id)?.publicTradedCompany == "false") ||
          (id == "parent" && stockSymbol.publicTradedCompany == "false") || (isEntityType("Sole Proprietorship")) ? (
          <div className="formcontrol ownershipTableContainer" aria-disabled={props?.disableFields}>
            <Table className="ownershipTable" >
              <thead>
                <tr className="headers">
                  <th>Type</th>
                  <th colSpan={2}>Full Name</th>
                  <th>% Ownership</th>
                  <th colSpan={2}>Home Address</th>
                  {id === "parent" ? (
                    <>
                      <th>{ismangeingMemberHeading()}</th>
                      <th>Authorized Signer</th>
                    </>
                  ) : (
                    ""
                  )}
                </tr>
              </thead>
              <tbody className="table-body" >
                {owners.map((row: any, index: number, { fields }: any) => (
                  <tr
                    key={index}
                  >
                    <td
                      width="50px"
                      onClick={() => {
                        updateIntialValues(row);
                        editEnable(row, index);
                      }}
                    >
                      {!(isEntityType("Sole Proprietorship")) && getOwner(row.ownerId).edit ? (
                        <div style={{ width: "60px" }}>
                          <Field
                            component={ReactSelectField}
                            //component={SelectField}
                            name="type"
                            label=""
                            helpText=""
                            options={typeValues}
                            value={row.type || row.type.value}
                            autoComplete="off"
                            disabled

                            onChange={(v: any) => {

                              changeField("type", v, id, row?.ownerId)
                            }
                            }
                            className="type"
                          />
                        </div>
                      ) : row.type === "Business" ? (
                        <img src={businessIcon} alt="businessIcon" />
                      ) : (
                        <img src={IndividualIcon} alt="IndividualIcon" />
                      )}
                    </td>
                    <td
                      colSpan={2}
                      onClick={() => {
                        updateIntialValues(row);
                        editEnable(row, index);
                      }}
                    >

                      {getOwner(row.ownerId).edit ?
                        row.type === "Business" ?
                          <div style={{ display: "flex" }}>
                            <div style={{ width: "400px" }}>
                              <Field
                                component={TextField}
                                name={`firstname`}
                                placeholder={"Business Name"}
                                helpText={""}
                                type={"text"}
                                autoComplete="off"
                                disabled={props.disableFields}
                                value={row.firstname}
                                textBlur={(e: any) => {
                                  if (!e.target.value) {
                                    e.target.classList.add('errorField')
                                  } else {
                                    e.target.classList.remove('errorField')
                                  }
                                  changeField(
                                    "firstname",
                                    e.target.value,
                                    id,
                                    row?.ownerId
                                  )
                                }
                                }

                              />
                            </div></div> : (
                            <div style={{ display: "flex" }}>
                              <div style={{ width: "80px" }}>
                                <Field
                                  component={TextField}
                                  name={`prefix`}
                                  placeholder={"Prefix"}
                                  helpText={""}
                                  type={"text"}
                                  autoComplete="off"
                                  disabled={props.disableFields}
                                  value={row.prefix}
                                  textBlur={(e: any) =>
                                    changeField("prefix", e.target.value, id, null)
                                  }
                                />
                              </div>
                              <Field
                                component={TextField}
                                size="2"
                                name={`firstname`}
                                placeholder={"FirstName"}
                                helpText={""}
                                type={"text"}
                                autoComplete="off"
                                disabled={props.disableFields}
                                value={row.firstname}
                                required
                                //validate={[ required, maxLength5 ]}
                                textBlur={(e: any) => {
                                  if (!e.target.value) {
                                    e.target.classList.add('errorField')
                                  } else {
                                    e.target.classList.remove('errorField')
                                  }
                                  changeField(
                                    "firstname",
                                    e.target.value,
                                    id,
                                    row?.ownerId
                                  )
                                }
                                }

                              />
                              <div style={{ width: "80px" }}>
                                <Field
                                  component={TextField}
                                  name={`middleName`}
                                  placeholder={"MI"}
                                  helpText={""}
                                  type={"text"}
                                  autoComplete="off"
                                  disabled={props.disableFields}
                                  value={row.middleName}
                                  textBlur={(e: any) =>
                                    changeField(
                                      "middleName",
                                      e.target.value,
                                      id,
                                      row?.ownerId
                                    )
                                  }
                                />
                              </div>
                              <Field
                                component={TextField}
                                name={`lastname`}
                                placeholder={"lastName"}
                                helpText={""}
                                type={"text"}
                                autoComplete="off"
                                value={row.lastname}
                                disabled={props.disableFields}
                                textBlur={(e: any) => {
                                  if (!e.target.value) {
                                    e.target.classList.add('errorField')
                                  } else {
                                    e.target.classList.remove('errorField')
                                  }
                                  changeField(
                                    "lastname",
                                    e.target.value,
                                    id,
                                    row?.ownerId
                                  )
                                }
                                }

                              />
                              <div style={{ width: "80px" }}>
                                <Field
                                  component={TextField}
                                  name={`suffix`}
                                  placeholder={"Suffix"}
                                  helpText={""}
                                  type={"text"}
                                  autoComplete="off"
                                  disabled={props.disableFields}
                                  textBlur={(e: any) =>
                                    changeField("suffix", e.target.value, id, null)
                                  }
                                />
                              </div>
                            </div>
                          ) : (
                          getName(row, "name")
                        )}
                    </td>
                    <td
                      width="65px"
                      onClick={() => {
                        updateIntialValues(row);
                        editEnable(row, index);
                      }}
                    >
                      {getOwner(row.ownerId).edit ? (
                        <Field
                          component={TextField}
                          name={`ownership`}
                          placeholder={"%"}
                          helpText={""}
                          type={"number"}
                          autoComplete="off"
                          disabled={props.disableFields}
                          min={0}
                          max={100}
                          value={row.ownership}
                          normalize={NormalizeNumber}
                          textBlur={(e: any) => {
                            if (getTotal(id, row?.ownerId) + (+e.target.value) > 100) {
                              if (!e.target.value) {
                                e.target.classList.add('errorField')
                              } else {
                                e.target.classList.remove('errorField')
                              }
                              // return false;
                            }
                            changeField(
                              "ownership",
                              +e.target.value,
                              id,
                              row?.ownerId
                            )

                          }
                          }
                        />
                      ) : (
                        row.ownership
                      )}
                    </td>

                    <td
                      colSpan={2}
                      onClick={() => {
                        updateIntialValues(row);
                        editEnable(row, index);
                      }}
                    >
                      {getOwner(row.ownerId).edit ? (
                        <div style={{ display: "flex" }}>
                          <Field
                            component={TextField}
                            name={`address1`}
                            placeholder={"Address"}
                            helpText={""}
                            type={"text"}
                            autoComplete="off"
                            disabled={props.disableFields}
                            value={row.address1}
                            textBlur={(e: any) => {
                              if (!e.target.value) {
                                e.target.classList.add('errorField')
                              } else {
                                e.target.classList.remove('errorField')
                              }
                              changeField(
                                "address1",
                                e.target.value,
                                id,
                                row?.ownerId
                              )

                            }
                            }


                          />
                          <Field
                            component={TextField}
                            name={`address2`}
                            placeholder={"Unit,Suite,etc"}
                            helpText={""}
                            type={"text"}
                            autoComplete="off"
                            disabled={props.disableFields}
                            value={row.address2}
                            textBlur={(e: any) =>
                              changeField(
                                "address2",
                                e.target.value,
                                id,
                                row?.ownerId
                              )
                            }
                          />

                          <Field
                            component={TextField}
                            name={`city`}
                            placeholder={"City"}
                            helpText={""}
                            type={"text"}
                            autoComplete="off"
                            disabled={props.disableFields}
                            value={row.city}
                            textBlur={(e: any) => {
                              if (!e.target.value) {
                                e.target.classList.add('errorField')
                              } else {
                                e.target.classList.remove('errorField')
                                changeField("firstname", e.target.value, id, null)
                              }
                              changeField(
                                "city",
                                e.target.value,
                                id,
                                row?.ownerId
                              )
                            }
                            }
                          />
                          <div className="state"
                            style={{ width: "70px" }}
                            onClick={() => {
                              updateIntialValues(row);
                              editEnable(row, index);
                            }}
                          >
                            {getOwner(row.ownerId).edit ? (
                              <Field
                                component={SelectField}
                                name="state"
                                helpText=""
                                values={states}
                                disabled={props.disableFields}
                                textBlur={
                                  (e: any) => {
                                    if (!e.target.value || e.target.value === 'select') {
                                      e.target.classList.add('errorField')
                                    } else {
                                      e.target.classList.remove('errorField')

                                    }
                                    changeField("state", e.target.value, id, null)

                                  }
                                }

                                onChange={(v: any) =>
                                  changeField(
                                    "state",
                                    v,
                                    id,
                                    row?.ownerId
                                  )
                                }
                              />
                            ) : (
                              row.state
                            )}
                          </div>

                          <div style={{ width: "100px" }}>
                            <Field
                              component={TextField}
                              name={`zipcode`}
                              placeholder={"ZipCode"}
                              helpText={""}
                              type={"text"}
                              autoComplete="off"
                              disabled={props.disableFields}
                              min={5}
                              value={row.zipcode}
                              normalize={normaliseZipcode}
                              textBlur={(e: any) => {
                                if (e.target.value.length < 5) {
                                  e.target.classList.add('errorField')
                                  return false;
                                }
                                e.target.classList.remove('errorField');
                                changeField(
                                  "zipcode",
                                  e.target.value,
                                  id,
                                  row?.ownerId
                                )
                              }
                              }
                            />
                          </div>
                        </div>
                      ) : (
                        getName(row, "address")
                      )}
                    </td>
                    {id === "parent" ? (
                      <>
                        <td
                          width="70px"
                          onClick={() => {
                            updateIntialValues(row);
                            editEnable(row, index);
                          }}
                        >
                          {getOwner(row.ownerId).edit ? (
                            <Field
                              component={SelectField}
                              name="corporateOfficer"
                              helpText=""
                              values={yesorNo}

                              placeholder={"N/A"}
                              disabled={(row.type === "Business" || props.disableFields)}
                              textBlur={
                                (e: any) => {
                                  if (!e.target.value || e.target.value === 'select') {
                                    e.target.classList.add('errorField')
                                  } else {
                                    e.target.classList.remove('errorField')

                                  }
                                  changeField("state", e.target.value, id, null)

                                }
                              }
                              onChange={(v: any) =>
                                changeField(
                                  "corporateOfficer",
                                  v,
                                  id,
                                  row?.ownerId
                                )
                              }
                            />
                          ) : (
                            row.corporateOfficer
                          )}
                        </td>
                        <td
                          width="70px"
                          onClick={() => {
                            updateIntialValues(row);
                            editEnable(row, index);
                          }}
                        >
                          {getOwner(row.ownerId).edit ? (
                            <div className="authSigner">
                              <Field
                                component={SelectField}
                                name="authSigner"
                                label=""
                                disabled={(row.type === "Business" || props.disableFields)}
                                textBlur={
                                  (e: any) => {
                                    if (!e.target.value || e.target.value === 'select') {
                                      e.target.classList.add('errorField')
                                    } else {
                                      e.target.classList.remove('errorField')

                                    }
                                    changeField("state", e.target.value, id, null)

                                  }
                                }
                                helpText=""
                                values={yesorNo}
                                onChange={(v: any) =>
                                  changeField("authSigner", v, id, row?.ownerId)
                                }
                              />
                            </div>
                          ) : (
                            row.authSigner
                          )}
                        </td>
                      </>
                    ) : (
                      ""
                    )}
                    <td className="delete">
                      {(id !== "parent" && getOwner(id)?.hasRemoveRow) ||
                        (id === "parent" && stockSymbol.hasRemoveRow) ? (
                        <div>
                          <div className="deleteimg">
                            {index !==
                              ((id !== "parent" && getOwner(id)?.selectedIndex) ||
                                (id === "parent" &&
                                  stockSymbol.selectedIndex)) ? (
                              <img
                                src={deleteIcon}
                                alt="Delete Icon"
                                onClick={(e: any) =>
                                  onDelete(e, index, id, row.ownerId)
                                }
                              />
                            ) : (
                              <img
                                src={deleteIcon}
                                alt="Delete Icon"
                                style={{ opacity: 0.6, cursor: "not-allowed" }}
                              />
                            )}
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </td>
                  </tr>
                ))}

                {(id !== "parent" && getOwner(id)?.publicTradedCompany == "false"
                  && (getOwner(id)?.newRow || !owners.length)) ||
                  (id === "parent" && stockSymbol.publicTradedCompany == "false" &&
                    (stockSymbol.newRow || !owners.length)) ? (
                  <tr className="entertext">
                    <td width="50px">
                      <div style={{ width: "60px" }}>{
                      }
                        {!(isEntityType("Sole Proprietorship")) ? <Field
                          component={ReactSelectField}
                          name={"type" + id}
                          label=""
                          helpText=""
                          autoComplete="off"
                          disabled={props.disableFields}
                          options={typeValues}
                          defaultValue={typeValues[0]}
                          value={owners.length ? props.newRowValues[id]?.type : { value: 'Individual' }}
                          textBlur={
                            (e: any, v: any) => {
                              if (!v.value) {
                                e.target.parentElement.parentElement.classList.add('errorField')
                              } else {
                                e.target.parentElement.parentElement.classList.remove('errorField')
                              }
                            }
                          }
                          onChange={(v: any) =>
                            changeField("type", v, id, null)
                          }
                          className="type"
                        /> : <><span><img src={IndividualIcon} alt="IndividualIcon" /> </span></>}
                      </div>
                    </td>
                    <td colSpan={2}>
                      {/* {newRowValues.type?.value== "Business" ?   */}
                      {props.newRowValues[id]?.type?.value == "Business" ?
                        <div style={{ display: "flex" }}>
                          <div style={{ width: "363px" }}>
                            {/* {JSON.stringify(`firstname${id}`)} */}
                            <Field
                              component={TextField}
                              name={`firstname` + id}
                              placeholder={"Business Name"}
                              helpText={""}
                              type={"text"}
                              autoComplete="off"
                              disabled={props.disableFields}
                              value={props.newRowValues[id]?.firstname}
                              textBlur={(e: any) => {
                                if (!e.target.value) {
                                  e.target.classList.add('errorField')
                                } else {
                                  e.target.classList.remove('errorField')
                                  changeField("firstname", e.target.value, id, null)
                                }

                              }
                              }
                            />
                          </div>
                        </div>

                        : ((props.newRowValues[id]?.type?.value == "Individuals" || !owners.length) ?
                          <div style={{ display: "flex" }}>
                            <div style={{ width: "80px" }}>
                              <Field
                                component={TextField}
                                name={`prefix` + id}
                                placeholder={"Prefix"}
                                helpText={""}
                                type={"text"}
                                autoComplete="off"
                                disabled={props.disableFields}
                                value={props.newRowValues[id]?.prefix}
                                textBlur={(e: any) =>
                                  changeField("prefix", e.target.value, id, null)
                                }
                              />
                            </div>
                            <Field
                              component={TextField}
                              size="20"
                              name={`firstname` + id}
                              placeholder={"FirstName"}
                              helpText={""}
                              type={"text"}
                              autoComplete="off"
                              disabled={props.disableFields}
                              textBlur={(e: any) => {
                                if (!e.target.value) {
                                  e.target.classList.add('errorField')
                                } else {
                                  e.target.classList.remove('errorField')
                                  changeField("firstname", e.target.value, id, null)
                                }

                              }
                              }
                            />
                            <div style={{ width: "80px" }}>
                              <Field
                                component={TextField}
                                name={`middleName` + id}
                                placeholder={"MI"}
                                helpText={""}
                                type={"text"}
                                autoComplete="off"
                                disabled={props.disableFields}
                                textBlur={(e: any) =>
                                  changeField(
                                    "middleName",
                                    e.target.value,
                                    id,
                                    null
                                  )
                                }
                              />
                            </div>
                            <Field
                              component={TextField}
                              name={`lastname` + id}
                              placeholder={"lastName"}
                              helpText={""}
                              type={"text"}
                              autoComplete="off"
                              disabled={props.disableFields}
                              textBlur={(e: any) => {
                                if (!e.target.value) {
                                  e.target.classList.add('errorField')
                                } else {
                                  e.target.classList.remove('errorField')
                                  changeField("lastname", e.target.value, id, null)
                                }

                              }
                              }
                            />
                            <div style={{ width: "80px" }}>
                              <Field
                                component={TextField}
                                name={`suffix11` + id}
                                placeholder={"Suffix"}
                                helpText={""}
                                type={"text"}
                                autoComplete="off"
                                disabled={props.disableFields}
                                textBlur={(e: any) =>
                                  changeField("suffix", e.target.value, id, null)
                                }
                              />
                            </div>
                          </div> : '')
                      }
                    </td>
                    <td width="65px">
                      <Field
                        component={TextField}
                        name={`ownership` + id}
                        placeholder={"%"}
                        helpText={""}
                        type={"number"}
                        value={props.newRowValues[id]?.ownership}
                        min={0}
                        max={100}
                        autoComplete="off"
                        disabled={props.disableFields}
                        normalize={NormalizeNumber}
                        textBlur={(e: any) => {
                          if (!e.target.value) {
                            e.target.classList.add('errorField')
                          }
                          if (getTotal(id) + (+e.target.value) > 100) {
                            e.target.classList.add('errorField')
                            return false;

                          }


                          changeField("ownership", +e.target.value, id, null)
                        }
                        }
                      />
                    </td>
                    <td colSpan={2}>
                      <div style={{ display: "flex" }}>
                        <Field
                          component={TextField}
                          name={`address1` + id}
                          placeholder={"Address"}
                          helpText={""}
                          type={"text"}
                          autoComplete="off"
                          textBlur={(e: any) => {
                            if (!e.target.value) {
                              e.target.classList.add('errorField')
                            } else {
                              e.target.classList.remove('errorField')
                              changeField("address1", e.target.value, id, null)
                            }

                          }

                          }
                        />
                        <Field
                          component={TextField}
                          name={`address2` + id}
                          placeholder={"Unit,Suite,etc"}
                          helpText={""}
                          type={"text"}
                          autoComplete="off"
                          disabled={props.disableFields}
                          textBlur={(e: any) =>
                            changeField("address2", e.target.value, id, null)
                          }
                        />

                        <Field
                          component={TextField}
                          name={`city` + id}
                          placeholder={"City"}
                          helpText={""}
                          type={"text"}
                          value={props.newRowValues[id]?.city}
                          autoComplete="off"
                          disabled={props.disableFields}
                          textBlur={(e: any) => {
                            if (!e.target.value) {
                              e.target.classList.add('errorField')
                            } else {
                              e.target.classList.remove('errorField')
                              changeField("city", e.target.value, id, null)
                            }

                          }
                          }
                        />

                        <div className="state" style={{ width: "70px" }}>
                          <Field
                            component={SelectField}
                            name={"states" + id}
                            helpText=""
                            defaultValue={" "}
                            values={states}
                            disabled={props.disableFields}
                            textBlur={

                              (e: any) => {
                                if (!e.target.value || e.target.value === 'select') {
                                  e.target.classList.add('errorField')
                                } else {
                                  e.target.classList.remove('errorField')
                                  changeField("state", e.target.value, id, null)
                                }
                              }
                            }
                            onChange={(v: any) =>
                              changeField("state", v, id, null)
                            }
                          />
                        </div>

                        <div style={{ width: "100px" }}>
                          <Field
                            component={TextField}
                            name={`zipcode` + id}
                            placeholder={"Zipcode"}
                            minLength={5}
                            helpText={""}
                            type={"text"}
                            autoComplete="off"
                            disabled={props.disableFields}
                            normalize={normaliseZipcode}
                            textBlur={(e: any) => {
                              if (e.target.value.length < 5) {
                                e.target.classList.add('errorField')
                                return false;
                              }
                              e.target.classList.remove('errorField');
                              changeField("zipcode", e.target.value, id, null)
                            }
                            }
                          />
                        </div>
                      </div>
                    </td>
                    {id === "parent" ? (
                      <>
                        <td width="70px">
                          <div className="corporateofficer">
                            <Field
                              component={SelectField}
                              name="corporateOfficer"
                              helpText=""
                              disabled={(props.newRowValues[id]?.type?.value == "Business" || props.disableFields)}
                              defaultValue={props.newRowValues[id]?.type?.value == "Business" ? "N/A" : ""}
                              values={yesorNo}
                              placeholder={"N/A"}
                              textBlur={
                                (e: any, v: any) => {
                                  if (v && !v.values) {
                                    e.target.classList.add('errorField')
                                  } else {
                                    e.target.classList.remove('errorField')
                                  }
                                }
                              }
                              onChange={(v: any) =>
                                !props.newRowValues[id]?.corporateOfficer && changeField("corporateOfficer", v, id, null)
                              }
                            />
                          </div>
                        </td>
                        <td width="70px">
                          <div className="authSigner">
                            <Field
                              component={SelectField}
                              name="authSigner"
                              label=""
                              disabled={(props.newRowValues[id]?.type?.value == "Business" || props.disableFields)}
                              helpText=""
                              defaultValue={props.newRowValues[id]?.type?.value == "Business" ? "N/A" : ""}
                              values={yesorNo}
                              textBlur={
                                (e: any, v: any) => {
                                  if (v && !v.values) {
                                    e.target.classList.add('errorField')
                                  } else {
                                    e.target.classList.remove('errorField')
                                  }
                                }
                              }
                              onChange={(v: any) =>
                                !props.newRowValues[id]?.authSigner && changeField("authSigner", v, id, null)
                              }
                            />
                          </div>
                        </td>
                      </>
                    ) : (
                      ""
                    )}
                  </tr>
                ) : (
                  ""
                )}
              </tbody>
              <tfoot>
                <tr className="footers">
                  {getTotal(id) === 100 ? (
                    <th colSpan={3} className="equalto">
                      Ownership must equal 100%
                    </th>
                  ) : (
                    <th colSpan={3} className="mustequal">
                      Ownership must equal 100%
                    </th>
                  )}

                  <th colSpan={2} className="percentage">
                    Total:&nbsp;
                    {getTotal(id) === 100 ? (
                      <span className="equalto">{getTotal(id)}%</span>
                    ) : (
                      <span className="mustequal">{getTotal(id)}%</span>
                    )}
                    {getTotal(id) === 100 ? (
                      <span className="equalto">/100%</span>
                    ) : (
                      <span>/100%</span>
                    )}
                  </th>

                  {id === "parent" ? (
                    <th colSpan={3}>
                      <div className="addandremovebtn">
                        <Button
                          disabled={(!isElgibleAddRow(id) || props.disableFields)}
                          className="submitmember"
                          onClick={(event: any) => addRow(event, id)}
                        >
                          Add Row
                        </Button>

                        {(id !== "parent" && getOwner(id)?.hasRemoveRow) ||
                          (id === "parent" && stockSymbol.hasRemoveRow) ? (
                          <Button
                            className="removemember"
                            onClick={() => hideRemove(id)}
                          >
                            Cancel
                          </Button>
                        ) : (
                          <Button
                            className="removemember"
                            onClick={() => displayRemove(id)}
                            disabled={props.disableFields}
                          >
                            Remove Row
                          </Button>
                        )}
                      </div>
                    </th>
                  ) : (
                    <th>
                      <div className="addandremovebtn">
                        <Button
                          disabled={(!isElgibleAddRow(id) || props.disableFields)}
                          className="submitmember"
                          onClick={(event: any) => addRow(event, id)}
                        >
                          Add Row
                        </Button>

                        {(id !== "parent" && getOwner(id)?.hasRemoveRow) ||
                          (id === "parent" && stockSymbol.hasRemoveRow) ? (
                          <Button
                            className="removemember"
                            onClick={() => hideRemove(id)}
                          >
                            Cancel
                          </Button>
                        ) : (
                          <Button
                            className="removemember"
                            onClick={() => displayRemove(id)}
                            disabled={props.disableFields}
                          >
                            Remove Row
                          </Button>
                        )}
                      </div>
                    </th>
                  )}
                </tr>
              </tfoot>
            </Table>

            <div
              className="removeConfirmationRow"
              style={{
                display: `${((id !== "parent" &&
                  (Number(getOwner(id)?.selectedIndex + "") >= 0
                    ? getOwner(id)?.selectedIndex
                    : -1)) ||
                  (id === "parent" &&
                    (Number(stockSymbol?.selectedIndex + "") >= 0
                      ? stockSymbol?.selectedIndex
                      : -1))) >= 0 &&
                  ((id !== "parent" && getOwner(id)?.hasRemoveRow) ||
                    (id === "parent" && stockSymbol.hasRemoveRow))
                  ? "flex"
                  : "none"
                  }`,
                top: targetTop,
              }}
            >
              <div></div>
              <div className="removeConfirmationText">
                Are you sure want to remove this row?
              </div>
              <div>
                <Button
                  className="removememberrow"
                  onClick={() => removeRowData(id)}
                >
                  Remove
                </Button>
                <Button
                  color="link"
                  //className="removemember"
                  onClick={() => changeSelectedIndex(id, -1)}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </>
    );
  };

  const renderBusinessQuestions = (_businessOwners: any) => {
    return Object.keys(_businessOwners.children).map((bo) => (
      <div key={bo} className="business_owners">
        {renderQuestion(bo, _businessOwners.children)}
        {renderBusinessQuestions(_businessOwners?.children[bo])}
        {/* {_businessOwners?.children[bo]?.children
          //.filter((o: any) => o.type === "Business")
          .forEach((_bo: any) => {
             if(_bo.owners){
                return renderBusinessQuestions(_bo)
             }
            })} */}
      </div>
    ));
  };

  return (
    <>
      <form className="ownership" ref={formElement}>
        {renderQuestion("parent")}
        {businessOwners?.parent?.children
          ? renderBusinessQuestions(businessOwners.parent)
          : ""}
        {/* {Object.keys(businessOwners)
          .filter((k) => k != "parent")
          .map((ownerId) => (
            <div key={ownerId} className="business_owners">
              {renderQuestion(ownerId)}
            </div>
          ))} */}
      </form>
    </>
  );
};

const mapStateToProps = (
  state: Record<string, unknown>,
  props: OwnershipQuestionnarieFormProps
) => {
  return {
    initialValues: {
      firstname: props.OwnershipInformationdata?.firstname,
      prefix: props.OwnershipInformationdata?.prefix,
      suffix: props.OwnershipInformationdata?.suffix,
      middleName: props.OwnershipInformationdata?.middlename,
      lastname: props.OwnershipInformationdata?.lastname,
      state: props.OwnershipInformationdata?.state,
      city: props.OwnershipInformationdata?.city,
      street: props.OwnershipInformationdata?.street,
      authSigner: props.OwnershipInformationdata?.authSigner,
      corporateOfficer: props.OwnershipInformationdata?.corporateOfficer,
      type: props.OwnershipInformationdata?.type,
      ownership: props.OwnershipInformationdata?.ownership,
      address1: props.OwnershipInformationdata?.address1,
      address2: props.OwnershipInformationdata?.address2,
      unit: props.OwnershipInformationdata?.unit,
      createdBy: props.OwnershipInformationdata?.createdBy,
      createdDate: props.OwnershipInformationdata?.createdDate,
      ownerId: props.OwnershipInformationdata?.ownerId,
      parentOwnerId: props.OwnershipInformationdata?.parentOwnerId,
      publicTradedCompany: props.OwnershipInformationdata?.publicTradedCompany,
      stockSymbol: props.OwnershipInformationdata?.stockSymbol,
      updatedBy: props.OwnershipInformationdata?.updatedBy,
      updatedDate: props.OwnershipInformationdata?.updatedDate,
      zipcode: props.OwnershipInformationdata?.zipcode,
      clientProductsId: props.clientProductsId,
    },
    newRowValues: props.newRowValues,
    formValues: getFormValues("OwnershipQuestionnarieForm")(state),
  };
};

export default connect((state: any) => {
  return {
    formValues: getFormValues("OwnershipQuestionnarieForm")(state),
  };
})(
  // eslint-disable-next-line @typescript-eslint/ban-types
  reduxForm<{}, OwnershipQuestionnarieFormProps>({
    form: "OwnershipQuestionnarieForm",
    //validate,
  })(OwnershipQuestionnarieForm)
);
